export const toggleValueInclusion = {
  methods: {
    toggle(valueOrValues) {
      const values = Array.isArray(valueOrValues) ? valueOrValues : [valueOrValues]
      const interim = new Set(this.value)

      for (const value of values) {
        if (interim.has(value)) {
          interim.delete(value)
        } else {
          interim.add(value)
        }
      }

      this.$emit('input', [...interim].sort())
    }
  }
}
